module.exports = __webpack_public_path__ + "static/media/halfCircleLightBlue.06af5218.svg";